import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 15 18.107"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #292A2E)",
      d: "M12.803 12.803 7.5 18.107l-5.303-5.304a7.5 7.5 0 1 1 10.606 0M7.5 10.833a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666m0-1.666a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334"
    }, null, -1)
  ]))]))
}
export default { render: render }